import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Loader from "../../../img/Document scan.gif"
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import Pagination from "../../Pagination";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";
import SplitPane from "react-split-pane";

const SiteSubjectEventStatusList = ({ onMouseDown, tableRef }) => {
  const [subjectEventStatusList, setSubjectEventStatusList] = useState([]);
  const [subjectEventStatusCount, setSubjectEventStatusCount] = useState(0);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectEventStatusCount / itemsPerPage);

  const getStudySubjectEventStatus = async () => {
    setDataLoader(true);
    let data = await studySiteDataEntryServices.getStudySubjectEventStatus(studyId, StudyMode, pageNumber, itemsPerPage);
    setSubjectEventStatusList(data?.data || [])
    setSubjectEventStatusCount(data?.totalRecords || 0)
    setDataLoader(false);
  };

  const downloadCSV = (data) => {
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Study Id",
      "Site Id",
      "Subject Id",
      "Event Id",
      "Time Point Id",
      "Data Entry Status",
      "Query Status",
      "Notification Status",
      "Reviewed Status",
    ];
    const rows = data.map((row, index) => [
      index + 1,
      row.studyName,
      row.siteName,
      row.subjectName,
      row.eventName,
      row.timePointName,
      row.entryStatus === "entry" ? "Entry" : "No Entry",
      row.queryStatus === "open" ? "Open" : row.queryStatus === "closed" ? "Closed" : "No Query",
      row.queryNotifyStatus === "open" ? "Open" : row.queryNotifyStatus === "closed" ? "Closed" : "No Notification",
      row.reviewStatus === "pending" ? "Pending" : "Reviewed",
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "subject_status.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = (data) => {
    if (!data || !data.length) return;
    const excelData = data.map((row, index) => ({
      "Sr.": index + 1,
      "Study Id": row.studyName,
      "Site Id": row.siteName,
      "Subject Id": row.subjectName,
      "Event Id": row.eventName,
      "Time Point Id": row.timePointName,
      "Data Entry Status": row.entryStatus === "entry" ? "Entry" : "No Entry",
      "Query Status": row.queryStatus === "open" ? "Open" : row.queryStatus === "closed" ? "Closed" : "No Query",
      "Notification Status": row.queryNotifyStatus === "open" ? "Open" : row.queryNotifyStatus === "closed" ? "Closed" : "No Notification",
      "Reviewed Status": row.reviewStatus === "pending" ? "Pending" : "Reviewed",
    }));
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Status");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "subject_status.xlsx");
  };

  useEffect(() => {
    getStudySubjectEventStatus();
  }, [pageNumber, itemsPerPage]);

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div></div>
        <div className="hstack gap-2">
          <div className="gap-1 hstack">
            <button
              onClick={() => downloadCSV(subjectEventStatusList)}
              className={`updateProfile`}
            >
              Download CSV
            </button>
            <button
              onClick={() => downloadExcel(subjectEventStatusList)}
              className={`updateProfile`}
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>
      <SplitPane
        split="horizontal"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {dataLoader ? (
          <PageLoader/>
        ) : subjectEventStatusCount === 0 ? (
          <NoDataFoundTable MSG={"Data Not Found!"} />
        ) : subjectEventStatusList?.length === 0 ? (
          <NoDataFoundTable MSG={"Search data Not Found!"} />
        ) : (
          <>
            <div className="overflow-auto">
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      className="text-center"
                      style={{ width: 45 }}
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Study Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Site Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Subject Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Event Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Time Point Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Data Entry Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 7)}>Query Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Notification Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 9)}>Reviewed Status</th>
                    <th className="text-center" onMouseDown={(e) => onMouseDown(e, 10)}>Event Color Status</th>
                  </tr>
                </thead>
                <tbody>
                  {(subjectEventStatusList || []).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>
                        {rowIndex + 1 + startIndex}
                      </td>
                      <td>{row?.studyName}</td>
                      <td>{row?.siteName}</td>
                      <td>{row?.subjectName}</td>
                      <td>{row?.eventName}</td>
                      <td>{row?.timePointName}</td>
                      <td className={`text-capitalize fw-bold ${row?.entryStatus === "entry" ? "text-warning" : "text-secondary"}`}>{row.entryStatus === "entry" ? "Entry" : "No Entry"}</td>
                      <td className={`text-capitalize fw-bold ${row?.queryStatus === "open" ? "text-danger" : row?.queryStatus === "closed" ? "text-success" : "text-secondary"}`}>{row.queryStatus === "open" ? "Open" : row.queryStatus === "closed" ? "Closed" : "No Query"}</td>
                      <td className={`text-capitalize fw-bold ${row?.queryNotifyStatus === "open" ? "text-purple" : row?.queryNotifyStatus === "closed" ? "text-success" : "text-secondary"}`}>{row.queryNotifyStatus === "open" ? "Open" : row.queryNotifyStatus === "closed" ? "Closed" : "No Notification"}</td>
                      <td className={`text-capitalize fw-bold ${row?.reviewStatus === "reviewed" ? "text-success" : "text-secondary"}`}>{row.reviewStatus === "reviewed" ? "Reviewed" : "Pending"}</td>
                      <td className="text-center">
                        <RiCheckboxBlankCircleFill
                          style={{ fontSize: 16 }}
                          className={row?.queryStatus === "open" ? "text-danger" : row?.queryNotifyStatus === "open" ? "text-purple" : row?.reviewStatus === "reviewed" ? "text-success" : row?.entryStatus === "entry" ? "text-warning" : "text-secondary"}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={subjectEventStatusCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default SiteSubjectEventStatusList;